<template>
  <!-- <div class="banner" :style="{ backgroundImage: `url('${src}')` }" 
    v-if="!$store.state.isMobile">
  </div> -->
  <div class="w-100">
    <img :src="src" class="img-fluid w-100" >
  </div>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    src: String
  }
}
</script>
